module.exports = __webpack_public_path__ + "static/img/花瓶14.7a9929a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶14.png
// module id = QTWi
// module chunks = 2